export default {
    manage_vehicleStatus: "Estado del Vehículo",
    manage_vehicleStatus_statusLabel: "Etiqueta de Estado",
    manage_vehicleStatus_vehicleStatusIcon: "Icono",
    manage_vehicleStatus_deleted: "Etiqueta de Estado fue eliminada exitosamente",
    manage_vehicleStatusList_deleted: "Etiquetas de Estados fueron eliminadas exitosamente",
    manage_vehicleStatus_search_by_status_label: "Buscar por Etiqueta de Estado"
  };
  